import { ErrorModalContent, Modal } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';
import { useSelector } from 'store/utils';

export const TreatmentAndDiagnosisErrorModal = () => {
  const dispatch = useDispatch();
  const errorMessage = useSelector(selectModalsErrors).treatmentAndDiagnosisError;

  const handleClose = () => {
    dispatch(appActions.setIsModalOpened({ isOpened: false, name: 'treatmentAndDiagnosisError' }));
  };

  return (
    <Modal title="Diagnosis and treatment plan" onClose={handleClose}>
      <ErrorModalContent
        onConfirm={handleClose}
        title="Diagnosis and treatment plan are not updated"
        subtitle={`Diagnosis and treatment plan are not updated${errorMessage ? `. ${errorMessage}` : ' due to technical issues'}`}
      />
    </Modal>
  );
};
